// extracted by mini-css-extract-plugin
export default {"bton":"btn_bton__zNgnY","btoff":"btn_btoff__CuQ5g"};